import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ShoppingBag, Bell, ArrowLeft, Sparkles } from 'lucide-react';

export const CheckoutPage = () => {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4" data-testid="checkout-coming-soon">
      <motion.div
        className="text-center max-w-lg"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <motion.div
          className="w-24 h-24 bg-gradient-to-br from-[#D4AF37]/20 to-[#D4AF37]/5 rounded-3xl flex items-center justify-center mx-auto mb-8"
          animate={{ rotate: [0, 5, -5, 0] }}
          transition={{ repeat: Infinity, duration: 4, ease: "easeInOut" }}
        >
          <ShoppingBag className="w-12 h-12 text-[#D4AF37]" />
        </motion.div>

        <h1 className="text-3xl md:text-4xl font-bold text-[#1A3625] mb-4">
          Online Sipariş Çok Yakında!
        </h1>

        <p className="text-lg text-[#5C5C5C] mb-6 leading-relaxed">
          KOSAD Ekosistem Marketi'nin online sipariş ve ödeme sistemi üzerinde çalışıyoruz. 
          Çok yakında doğal bal ve arı ürünlerini kapınıza kadar getireceğiz.
        </p>

        <div className="bg-[#F9F8F6] rounded-2xl p-6 mb-8 border border-[#E5DAC8]/50">
          <div className="flex items-center justify-center gap-2 mb-3">
            <Sparkles className="w-5 h-5 text-[#D4AF37]" />
            <p className="text-base font-semibold text-[#1A3625]">Neler Geliyor?</p>
          </div>
          <ul className="space-y-2 text-base text-[#5C5C5C]">
            <li>Güvenli online ödeme altyapısı</li>
            <li>Kapıda ödeme seçeneği</li>
            <li>Türkiye geneli kargo ile teslimat</li>
            <li>Sipariş takip sistemi</li>
          </ul>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/market"
            className="inline-flex items-center justify-center gap-2 bg-[#1A3625] text-white px-6 py-3 rounded-full text-base font-medium hover:bg-[#1A3625]/90 transition-colors"
            data-testid="back-to-market-btn"
          >
            <ArrowLeft className="w-5 h-5" />
            Markete Dön
          </Link>
          <Link
            to="/iletisim"
            className="inline-flex items-center justify-center gap-2 border-2 border-[#D4AF37] text-[#D4AF37] px-6 py-3 rounded-full text-base font-medium hover:bg-[#D4AF37]/5 transition-colors"
            data-testid="contact-btn"
          >
            <Bell className="w-5 h-5" />
            Bize Ulaşın
          </Link>
        </div>

        <p className="mt-8 text-sm text-[#8C7A6B]">
          Sipariş vermek isterseniz bize iletişim sayfasından veya telefonla ulaşabilirsiniz.
        </p>
      </motion.div>
    </div>
  );
};
